import { connect } from 'react-redux'
import { createAuthStateToProps } from 'helpers/auth'
import selectors from 'selectors'
import assetActions from 'actions/assets'
import assetCategoryActions from 'actions/assetCategories'
import jobActions from 'actions/jobs'
import locationActions from 'actions/locations'
import locationGroupActions from 'actions/locationGroups'
import operatorActions from 'actions/operators'
import operatorGroupActions from 'actions/operatorGroups'
import productCategoryActions from 'actions/productCategories'
import supplierActions from 'actions/suppliers'
import userActions from 'actions/users'
import Component from 'components/Reports/InventoryIssueStatusReport/Filter'

const mapStateToProps = (state, props) => ({
  ...createAuthStateToProps(state, props),
  assetCategories: selectors.assetCategories.selectOptions(state),
  assets: selectors.assets.selectOptions(state, { itemsOnly: false }),
  jobs: selectors.jobs.selectOptions(state, { itemsOnly: false }),
  locationGroups: selectors.locationGroups.selectOptions(state),
  locations: selectors.locations.selectOptions(state),
  operatorGroups: selectors.operatorGroups.selectOptions(state),
  operators: selectors.operators.selectOptions(state, { itemsOnly: false }),
  productCategories: selectors.productCategories.selectOptions(state),
  suppliers: selectors.suppliers.selectOptions(state, { itemsOnly: false }),
  users: selectors.users.selectOptions(state),
})

const mapDispatchToProps = (dispatch, props) => ({
  getAssetCategories: (params) => dispatch(assetCategoryActions.getOptions(params)),
  getAssets: (params) => dispatch(assetActions.getOptions({ ...params, pageIndex: 1, pageSize: 100 })),
  getLocationGroups: (params) => dispatch(locationGroupActions.getOptions(params)),
  getLocations: (params) => dispatch(locationActions.getOptions({ locationVendingTypes: ['NonVending'], ...params })),
  getSuppliers: (params) =>
    dispatch(
      supplierActions.getOptions({
        pageIndex: 1,
        pageSize: 100,
        ...params,
        active: 'All',
      }),
    ),
  getProductCategories: (params) =>
    dispatch(productCategoryActions.getOptions({ ...params, active: 'All', pageIndex: 0 })),
  getOperatorGroups: (params) => dispatch(operatorGroupActions.getOptions(params)),
  getJobs: (params) =>
    dispatch(
      jobActions.getOptions({
        pageIndex: 1,
        pageSize: 100,
        ...params,
        active: 'All',
      }),
    ),
  getOperators: (params) =>
    dispatch(
      operatorActions.getOptions({
        pageIndex: 1,
        pageSize: 100,
        ...params,
        active: 'All',
      }),
    ),
  getUsers: (params) => dispatch(userActions.getOptions({ ...params, active: 'All' })),
})

export default connect(mapStateToProps, mapDispatchToProps)(Component)
